import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.move', {
        url: '/move',
        params: {accounts: []},
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsMove'
        },
        resolve: {
            accounts,
            groups,
        },
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/** @ngInject */
function groups(companyId, groupId, GroupsResource) {
    return GroupsResource.getAllCustomAndApplication(companyId)
        .then((groups) => groups.filter(({id}) => id !== groupId))
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/move/move-accounts-to-group.state.js